import type { Locale, SectorContent } from '../types';
import { chrome } from '../i18n';
import type { SegmentSelection } from '../core/segments';

export function FilterControls(
  content: SectorContent,
  locale: Locale,
  sel: SegmentSelection,
): string {
  const c = chrome(locale);
  const years = content.filters.years
    .map((y, i) => `<option value="${i}" ${i === sel.year ? 'selected' : ''}>${y}</option>`)
    .join('');
  const stages = content.filters.stages
    .map((s, i) => `<option value="${i}" ${i === sel.stage ? 'selected' : ''}>${s}</option>`)
    .join('');
  return `
    <label class="ctl"><span>${c.yearLabel}</span>
      <select id="yearSel" aria-label="${c.yearLabel}">${years}</select>
    </label>
    <label class="ctl"><span>${c.stageLabel}</span>
      <select id="stageSel" aria-label="${c.stageLabel}">${stages}</select>
    </label>`;
}
